module.exports = __webpack_public_path__ + "media/packs/images/flags/DZ-1726cc7de91401a2c6d5efcc4c5187b4.svg";